import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import NavbarHome from "../../../components/ui/NavbarHome";
import { LoaderIcon } from "../../../components/ui/Swicons";
import { devURL, mailformat } from "../../../utils";

export default function ForgotPassword() {
  const { register, handleSubmit } = useForm();
  const [data, setData] = useState("");
  const [loader, isLoading] = useState(false);
  const navigate = useNavigate();
  const [isDisabledLogin, setDisabledLogin] = useState(true);
  const initialValues = { email: "" };
  const [formValues, setFormValues] = useState(initialValues);

  useEffect(() => {
    if (
      localStorage.getItem("swToken") &&
      localStorage.getItem("swToken") != ""
    ) {
      navigate("/Change-Password");
    }
  }, []);

  const handleChange = (e) => {
    if (e.target.name === "email" && e.target.value.length >= 0) {
      formValues.email = e.target.value;
    }
    if (formValues.email !== "") setDisabledLogin(false);
    else setDisabledLogin(true);
    //console.log(formValues);
  };

  const onSubmit = (val) => {
    isLoading(true);
    if (val.email === "") {
      toast.error("Please enter your email.");
      isLoading(false);
    } else if (!val.email.match(mailformat)) {
      toast.error("You have entered an invalid email address!.");
      isLoading(false);
    } else {
      isLoading(true);
      val.email = val.email.toLowerCase();
      axios
        .get(`${devURL}/user/forgot-password?email=` + val.email)
        .then((res) => {
          if (res.data.status) {
            isLoading(false);
            toast.success(res.data.message);
            navigate("/Login");
            //navigate("/reset-password");
          } else {
            isLoading(false);
            toast.error(`Incorrect email address`);
          }
        })
        .catch((err) => {
          isLoading(false);
          if (
            err.response &&
            err.response.data &&
            err.response.data.errorMessage
          ) {
            toast.error(err.response.data.errorMessage);
          }
        });
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div>
        <NavbarHome />
        <div className="min-h-full relative flex items-center justify-center sm:mt-24 mt-8 sm:px-6 lg:px-8">
          <div className="max-w-xl w-full bg-white p-4 shadow-lg rounded-xl border-2 space-y-8 sm:mx-0 mx-6">
            <div>
              <h2 className="mt-6 text-center text-3xl font-nunito font-semibold text-gray-900">
                Reset Password
              </h2>
            </div>
            <div className="rounded-md shadow-sm space-y-4">
              <div>
                <label htmlFor="email" className="font-light">
                  Email address<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  {...register("email")}
                  name="email"
                  onChange={handleChange}
                  className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                  placeholder="Enter your email here."
                />
              </div>
            </div>
            <div className="mb-28">
              <button
                type="submit"
                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white"
                style={
                  !isDisabledLogin
                    ? { backgroundColor: "#3580c0" }
                    : { backgroundColor: "#3580c0", opacity: "50%" }
                }
                disabled={isDisabledLogin}
              >
                {loader && <LoaderIcon />}
                {!loader && <>Reset Password</>}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}
